export const BANDWIDTH_PROFILES = {
  normal: {
    video: {
      maxBitrate: 1_500_000, // ~1.5 Mbps
      maxFramerate: 30,
      scaleResolutionDownBy: 1
    }
  },
  low: {
    video: {
      maxBitrate: 150_000,   // ~150 kbps
      maxFramerate: 12,
      scaleResolutionDownBy: 2
    }
  }
};

export function applyBandwidthProfile(peerConnection, profile) {
  const settings = BANDWIDTH_PROFILES[profile];
  if (!settings) return;

  peerConnection.getSenders().forEach(sender => {
    if (sender.track?.kind === "video") {
      const params = sender.getParameters();
      params.encodings = [ settings.video ];
      sender.setParameters(params).catch(err =>
        console.warn("⚠️ Failed to apply bandwidth profile:", err)
      );
    }
  });
}